(function () {
  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatLabel(title, quantity) {
    var qty = parseInt(quantity, 10);
    if (!isNaN(qty) && qty > 1) {
      return title + ' \u00d7 ' + qty;
    }
    return title;
  }

  function listHasItems(list) {
    return list.querySelector('.codex-checklist__item') !== null;
  }

  function getProductTitle(entry) {
    if (!entry) return '';
    if (typeof entry === 'string') return entry;
    return entry.title || entry.name || entry.public_title || entry.product_title || '';
  }

  function normalizeEntries(entries) {
    var items = [];
    var seen = {};

    function addItem(title, quantity) {
      var cleanTitle = (title || '').trim();
      if (!cleanTitle) return;

      var key = cleanTitle.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;

      items.push({
        title: cleanTitle,
        quantity: quantity || 1
      });
    }

    if (!entries) return items;

    if (Array.isArray(entries)) {
      entries.forEach(function (entry) {
        addItem(getProductTitle(entry), entry && entry.quantity);
      });
      return items;
    }

    if (typeof entries === 'object') {
      Object.keys(entries).forEach(function (key) {
        var entry = entries[key];
        addItem(getProductTitle(entry), entry && entry.quantity);
      });
    }

    return items;
  }

  function collectBundleItems(bundle, productId) {
    var items = [];
    var currentId = String(productId || '');

    if (!bundle || typeof bundle !== 'object') return items;

    items = items.concat(normalizeEntries(bundle.required_products));

    if (Array.isArray(bundle.sections)) {
      bundle.sections.forEach(function (section) {
        if (!section || !section.products) return;
        items = items.concat(normalizeEntries(section.products));
      });
    }

    if (bundle.products) {
      var productEntries = normalizeEntries(bundle.products);
      if (productEntries.length === 1 && currentId && bundle.products[currentId]) {
        return items;
      }
      items = items.concat(productEntries);
    }

    return items;
  }

  function findBundleItems(bundles, productId, productHandle) {
    if (!Array.isArray(bundles)) return [];

    var currentId = String(productId || '');
    var currentHandle = String(productHandle || '');

    for (var i = 0; i < bundles.length; i++) {
      var bundle = bundles[i];
      if (!bundle) continue;

      var matchesProduct =
        (currentId && bundle.products && bundle.products[currentId]) ||
        (currentHandle &&
          bundle.products &&
          Object.keys(bundle.products).some(function (key) {
            var entry = bundle.products[key];
            return entry && entry.handle === currentHandle;
          }));

      if (matchesProduct) {
        var items = collectBundleItems(bundle, currentId);
        if (items.length) return items;
      }
    }

    for (var j = 0; j < bundles.length; j++) {
      var fallbackBundle = bundles[j];
      var fallbackItems = collectBundleItems(fallbackBundle, currentId);
      if (fallbackItems.length) return fallbackItems;
    }

    return [];
  }

  function renderItems(list, items) {
    if (!list || listHasItems(list) || !items.length) return false;

    items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'codex-checklist__item';
      row.setAttribute('data-codex-bundle-item', '');
      row.innerHTML =
        '<span class="codex-checklist__check">\u2713</span>' +
        '<span>' +
        escapeHtml(formatLabel(item.title, item.quantity)) +
        '</span>';
      list.appendChild(row);
    });

    if (listHasItems(list)) {
      list.removeAttribute('data-needs-js');
      list.closest('.codex-buy__included')?.removeAttribute('hidden');
      return true;
    }

    return false;
  }

  function populateLists(sourceItems) {
    var items = normalizeEntries(sourceItems);
    if (!items.length) return;

    document.querySelectorAll('[data-codex-bundle-list][data-needs-js="true"]').forEach(function (list) {
      renderItems(list, items);
    });
  }

  function populateFromBundler() {
    if (typeof window.bndlr === 'undefined' || typeof window.bndlr.getBundles !== 'function') {
      return;
    }

    document.querySelectorAll('[data-codex-bundle-list][data-needs-js="true"]').forEach(function (list) {
      if (listHasItems(list)) return;

      var items = findBundleItems(
        window.bndlr.getBundles(),
        list.dataset.productId,
        list.dataset.productHandle
      );

      renderItems(list, items);
    });
  }

  function hideEmptyLists() {
    document.querySelectorAll('[data-codex-bundle-list][data-needs-js="true"]').forEach(function (list) {
      if (!listHasItems(list)) {
        list.closest('.codex-buy__included')?.setAttribute('hidden', '');
      }
    });
  }

  function init() {
    document.addEventListener('bundler:loaded', populateFromBundler);
    document.addEventListener('bundler:bundle_widget_created', function (event) {
      if (event && event.detail && event.detail.products) {
        populateLists(event.detail.products);
      }
      populateFromBundler();
    });

    populateFromBundler();

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      populateFromBundler();

      if (attempts >= 40 || !document.querySelector('[data-codex-bundle-list][data-needs-js="true"]')) {
        window.clearInterval(timer);
        hideEmptyLists();
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
